import PopUp from "../PopUp";
import React from "react";

import GraphArea from "../icons/GraphArea";
import GraphDeviation from "../icons/GraphDeviation";
import GraphPoints from "../icons/GraphPoints";
import { languageContent } from "../../@helpers";

const Legend = ({ dataSet, showHeight }) => {
  const content = languageContent();
  const { component } = content;
  const {
    spanTagFirst,
    spanTagSecond,
    spanTagThird,
    heightText,
    weightText,
    pTagFirst,
    pTagSecond,
    graphDeviation,
    dataSetUK,
    dataSetUS
  } = component.Legend;

  return (
    <ul>
      <li>
        <span className="icon">
          <GraphPoints />
        </span>
        {spanTagFirst} {showHeight ? heightText : weightText}
      </li>
      <li>
        <span className="icon">
          <GraphArea />
        </span>{" "}
        {spanTagSecond}{" "}
        {(dataSet === "who" ||
          dataSet === "uk" ||
          dataSet === "us") && (
            <PopUp>
              {(dataSet === "who" || dataSet === "es-who") && (
                <div className="popup_content">
                  <p>{pTagFirst} </p>
                  <p>{pTagSecond}</p>
                </div>
              )}
              {dataSet === "uk" && (
                <div className="popup_content">
                  <p>{dataSetUK}</p>
                </div>
              )}
              {dataSet === "us" && (
                <div className="popup_content">
                  <p>{dataSetUS}</p>
                </div>
              )}
            </PopUp>
          )}
      </li>
      <li>
        <span className="icon">
          <GraphDeviation />
        </span>{" "}
        {spanTagThird}{" "}
        <PopUp>
          <div className="popup_content">
            <p className="popup_title">{graphDeviation.pTagFirst}</p>
            <p>{graphDeviation.pTagSecond}</p>
            <p className="popup_title">{graphDeviation.pTagThird}</p>
            <p>{graphDeviation.pTagFourth}</p>
            <p className="popup_title">{graphDeviation.pTagFifth}</p>
            <p>{graphDeviation.pTagSixth}</p>
          </div>
        </PopUp>
      </li>
    </ul>
  );
};

export default Legend;
